<template>
  <div
    :class="[
      'alreadyHaveAccount d-flex align-items-center full-width',
      {'alreadyHaveAccount--hidden': !show }]"
  >
    <div class="pr-3 color-ink-light">
      {{ this.$t('Views.user_signup.general.already_account') }}
    </div>
    <MuiButtonFlat
      size="m"
      type="main--offset"
      @click.native="goLogin"
    >
      {{ this.$t('Views.user_signup.general.login') }}
    </MuiButtonFlat>
  </div>
</template>
<script>
import { MuiButtonFlat } from '@ubeeqo/motion-ui';

export default {
  components: {
    MuiButtonFlat,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goLogin() {
      this.$router.push('/');
    },
  },
};
</script>
